// extracted by css-extract-rspack-plugin
export default {"modalFooter":"opy_9RZi4cppXUDL"};